module.exports = __webpack_public_path__ + "static/media/sass.d9465d84.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/sass.png
 ** module id = 233
 ** module chunks = 0
 **/